//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import registrationCopy from "../../../../data/registrationPage.json"
import verify from "../../../../js/utils/_passwordVerify.js"
import { mapGetters, mapMutations, mapActions } from "vuex";
import AlertError from "../components/AlertError.vue"
export default {
	name: "PageRegistration",
	components: {
		AlertError,
	},
	data() {
		return{
			copy: registrationCopy.registrationPage.default,
			registerEndpoint: '/api/account/register',
			registerSettingsEndpoint: '/api/account/registrationformsettings',
			registerCountries: [],
			registerRoles: [],
			registerPardotCheckboxText: '',
			isZipCode: true,
			passwordFieldReveal: false,
			copyHTML: '',
			formData: {
				registerEmailAddress: '',
				registerPassword: '',
				registerFirstName: '',
				registerLastName: '',
				registerCountry: '',
				registerZipcode: '',
				registerInvestor: '',
				registerEmailSignup: false
			},
			errorMsg: [

			],
			passwordIsValid: false,
		}
	},
	computed: {
		...mapGetters(["isError", "isDisabled", "isLoading"]),
        primaryError() {
            if (!this.isError || this.isError.length === 0)
                return false;

            let primErr = false;

            this.isError.forEach((err) => {
                if (!primErr && err?.code !== "DuplicateUserName")
                    primErr = err;
            });

            return primErr;
        }
	},
	methods: {
		...mapMutations(["setRegistration","setAccountExist","setAuthenticated", "setOptionalEmail", "setOptionalQuestions", "setError", "setDisabled", "setLoading","setRegistrationPage"]),
		...mapActions(["getData","getAccountInfo","getAccountCookies","setAccountInfo"]),
		loginPage() {
			this.setAuthenticated(false)
			this.setAccountExist(true)
		},
		processRegistrationData(data) {
			data.preventDefault()
			// do stuff
			// remove any errant zipcode stuff when not USA
			if(!this.isZipCode) {
				this.formData.registerZipcode = ''
			}
			const formData = Object.assign({},this.formData)
			formData.endpoint = this.registerEndpoint;
			const afToken = this.$root.token;
			this.setError(false)
			this.setDisabled(true)
			this.setLoading(true)
			this.setAccountInfo({formData, afToken})
			// this.setAccountExist(true)
			// this.setOptionalQuestions(true)
		},
		togglePasswordVisibility() {
			this.passwordFieldReveal = !this.passwordFieldReveal
		},
		handleNewPasswordInput(e) {
			let value = e.target.value;
			let container = this.$el.querySelector(".registration-page__password-wrapper");
			let explanation = this.$el.querySelector(".registration-page__password-explanation");
			verify(container, explanation, value);
			if (container.matches('[data-strength="5"]')) this.passwordIsValid = true;
			else this.passwordIsValid = false;
		}
	},
	watch: {
		'formData.registerCountry'(newCountry) {
			// if not america, turn off zipcode field
			newCountry !== '271' ? this.isZipCode = false : this.isZipCode = true
		}
	},
	mounted() {
		// doing two fetches seems bad
		this.setLoading(true)
		this.setError(false)

		fetch(this.registerSettingsEndpoint, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json'
			},
		}).then((response) => response.json())
			.then((data) => {
				var registerFormSettings = JSON.parse(JSON.stringify(data))
				this.registerCountries = registerFormSettings.countries;
				this.registerRoles = registerFormSettings.roles;
				this.registerPardotCheckboxText = registerFormSettings.pardotCheckboxText;
				setTimeout(() => {
					this.setLoading(false)
				}, 1000);
		});
	}
};
